import React, { useEffect, useRef, useContext } from 'react';
import lottie from 'lottie-web';
import { ParentContext } from '../card';

function Lottie({ animationData }: { animationData: string }) {
  const container = useRef(null);
  const parentContext = useContext(ParentContext);

  const animRef = useRef(null);
  const isHoveredRef = useRef(false);

  useEffect(() => {
    animRef.current = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: animationData,
    });

    animRef.current.addEventListener('complete', () => {
      animRef.current.resetSegments(true);
    });

    return () => {
      animRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    if (parentContext !== isHoveredRef.current) {
      isHoveredRef.current = parentContext;

      if (isHoveredRef.current) {
        animRef.current.play();
      }
    }
  }, [parentContext]);

  return (
    <div
      onMouseEnter={() => {
        animRef.current.play();
      }}
      ref={container}
    />
  );
}

export default Lottie;
